<template>
    <div class="multistep-indicator">
        <div v-if="showExplanation" class="step-explanation">
            <div
                v-for="(item, index) in multistepIndicatorSteps"
                :key="index"
                class="step"
            >
                <h5>{{ item.heading }}</h5>
                <p>{{ item.description }}</p>
            </div>
        </div>
        <div class="step-navigation">
            <template
                v-for="(item, index) in multistepIndicatorSteps"
                :key="index"
            >
                <router-link :to="item.link">
                    <div
                        :class="[
                            'bubble',
                            { filled: `step${index + 1}` <= currentStep },
                        ]"
                    >
                        {{ index + 1 }}
                    </div>
                </router-link>
                <div
                    v-if="index !== multistepIndicatorSteps.length - 1"
                    class="line"
                    ref="line"
                >
                    <div
                        class="fill"
                        :style="{
                            width:
                                `step${index + 1}` < currentStep
                                    ? '100%'
                                    : '0%',
                        }"
                    ></div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import EventBus from "../event-bus";
export default {
    name: "MultiStepIndicator",
    props: {
        showExplanation: {
            type: Boolean,
            default: true,
            required: true,
        },
        multistepIndicatorSteps: {
            type: Array,
            default: () => [],
            required: true,
        },
    },
    computed: {
        currentStep() {
            const path = window.location.hash || this.$route.path;
            return path.split("/").pop();
        },
    },
    methods: {
        setFirstLineFillWidth(args) {
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    if (!this.$refs.line || this.$refs.line.length === 0) {
                        return;
                    }

                    const fillElement =
                        this.$refs.line[0].querySelector(".fill");
                    if (!fillElement) {
                        return;
                    }

                    const currentTab = args[0];
                    const tabLength = args[1];

                    if (currentTab === 0) {
                        fillElement.style.width = "0%";
                    } else {
                        const fillWidth = (currentTab / tabLength) * 100;
                        fillElement.style.width = `${fillWidth}%`;
                    }
                });
            });
        },
    },
    mounted() {
        EventBus.on("tabChanged", this.setFirstLineFillWidth);
    },
    beforeUnmount() {
        EventBus.off("tabChanged", this.setFirstLineFillWidth);
    },
};
</script>

<style lang="scss" scoped>
@use "@/assets/customizer.mixins.scss" as *;
.multistep-indicator {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 24px;
    width: 100%;

    .step-explanation {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        padding: 0 24px;

        @media (max-width: $breakpoint-mobile) {
            display: none;
        }

        .step {
            width: 33%;
            max-width: 200px;

            h5 {
                text-align: center;
            }

            p {
                margin: 8px 0 0;
                text-align: center;

                & {
                    @include font-body-s;
                }
            }
        }
    }

    .step-navigation {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        max-width: 520px;

        @media (max-width: $breakpoint-mobile) {
            column-gap: 8px;
            padding: 0 16px;
        }

        a {
            display: block;
            text-decoration: none;
        }

        .line {
            position: relative;
            width: 100%;
            max-width: 156px;
            height: 5px;
            border-radius: 40px;
            background-color: $color-normal-grey;
            overflow: hidden;

            .fill {
                position: absolute;
                top: 0;
                left: 0;
                display: block;
                width: 0;
                height: 100%;
                background-color: $color-new-black;
                transition: width 0.3s;
            }
        }
    }
}
</style>
